import { some } from 'lodash';

export function hasDuplicatesValue(array: Record<string, any>[], property: string): boolean {
  const seen = new Set();
  return some(array, (item) => {
    if (seen.has(item[property])) {
      return true;
    }
    seen.add(item[property]);
  });
}

export function lastIndex<T>(array: T[], fn: (element: T) => boolean): number {
  for (let i = array.length - 1; i >= 0; i--) {
    if (fn(array[i])) {
      return i;
    }
  }
  return -1;
}
